import { Link } from 'react-router-dom';
import { T } from '@tolgee/react';

// Iconos de redes sociales como componentes funcionales
const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" />
  </svg>
)

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
)

const YoutubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
)

// Categorías de productos
const productCategories = [
  { id: "1", name: "Perros", nameKey: "animal_categories.perros", handle: "perros" },
  { id: "2", name: "Gatos", nameKey: "animal_categories.gatos", handle: "gatos" },
  { id: "3", name: "Aves", nameKey: "animal_categories.aves", handle: "aves" },
  { id: "4", name: "Roedores", nameKey: "animal_categories.roedores", handle: "roedores" }
];

const Footer = () => {
  return (
    <footer className="w-full text-white" style={{ backgroundColor: '#0d0d0d' }} data-testid="footer">
      {/* Sección principal del footer */}
      <div className="content-container pt-16 pb-8">
        {/* Primera fila: Logo y descripción */}
        <div className="mb-12">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
            <div className="md:max-w-xl">
              <Link to="/" className="block mb-4" data-testid="footer-logo-link">
                <img src="/Logo.svg" alt="Jarad" className="h-10 w-auto" />
              </Link>
              <p className="text-gray-400 text-sm leading-relaxed">
                <T keyName="footer.about">
                  Jarad Pet Food es una marca especializada en alimentación natural para mascotas. Desarrollamos alimentos y suplementos para aves, roedores, perros y gatos con ingredientes seleccionados, control total del proceso y más de 20 años de experiencia, para cuidar su salud, bienestar y vitalidad cada día.
                </T>
              </p>
            </div>
            {/* Redes sociales */}
            <div className="flex-shrink-0">
              <h3 className="font-medium text-white mb-4 text-sm">
                <T keyName="footer.follow_us">Síguenos</T>
              </h3>
              <div className="flex space-x-4">
                <a href="https://www.instagram.com/jaradpetfood/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-200" aria-label="Instagram">
                  <InstagramIcon />
                </a>
                <a href="https://www.facebook.com/jaradpetfood" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-200" aria-label="Facebook">
                  <FacebookIcon />
                </a>
                <a href="https://www.youtube.com/@JaradPetFood" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition duration-200" aria-label="YouTube">
                  <YoutubeIcon />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Segunda fila: 5 columnas */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {/* Categorías */}
          <div>
            <h3 className="font-medium text-white mb-4 text-sm">
              <T keyName="footer.categories">Categorías</T>
            </h3>
            <ul className="space-y-2">
              {productCategories.map((c) => (
                <li key={c.id}>
                  <Link className="text-gray-400 hover:text-white text-sm transition duration-200" to={`/categorias/${c.handle}`}>
                    <T keyName={c.nameKey}>{c.name}</T>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="font-medium text-white mb-4 text-sm">
              <T keyName="footer.quick_links">Enlaces rápidos</T>
            </h3>
            <ul className="space-y-2">
              <li><Link to="/about-us" className="text-gray-400 hover:text-white text-sm transition duration-200"><T keyName="footer.about_us">Sobre nosotros</T></Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white text-sm transition duration-200"><T keyName="footer.faq">Preguntas frecuentes</T></Link></li>
              <li><Link to="/contacto" className="text-gray-400 hover:text-white text-sm transition duration-200"><T keyName="footer.contact">Contacto</T></Link></li>
              <li><Link to="/terminos-y-condiciones" className="text-gray-400 hover:text-white text-sm transition duration-200"><T keyName="footer.terms">Términos y condiciones</T></Link></li>
              <li><Link to="/politica-de-privacidad" className="text-gray-400 hover:text-white text-sm transition duration-200"><T keyName="footer.privacy">Política de privacidad</T></Link></li>
            </ul>
          </div>

          {/* Cash Jarad Sevilla */}
          <div>
            <h3 className="font-medium text-white mb-4 text-sm">Cash Jarad Sevilla</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Av. Hacienda San Antonio, 23</li>
              <li>41016 Sevilla</li>
              <li>Tel: 647 434 877</li>
              <li>Lun-Jue: 8:00h-17:00h</li>
              <li>Vie: 7:00h-15:00h</li>
            </ul>
          </div>

          {/* Cash Jarad El Coronil */}
          <div>
            <h3 className="font-medium text-white mb-4 text-sm">Cash Jarad El Coronil</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Carretera de Utrera, 19</li>
              <li>41760 El Coronil, Sevilla</li>
              <li>Tel: 661 266 270</li>
              <li>Lun-Vie: 8:00h-14:00h / 15:30h-18:00h</li>
              <li>Sáb: 8:00h-13:00h</li>
            </ul>
          </div>

          {/* Información Oficina */}
          <div>
            <h3 className="font-medium text-white mb-4 text-sm">
              <T keyName="footer.office_info">Información Oficina</T>
            </h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>C/ Ctra. de Utrera, 19-A</li>
              <li>41760 El Coronil, Sevilla</li>
              <li>info@jaradpetfood.com</li>
              <li>+34 955 83 68 23</li>
              <li>Lun-Vie: 8:00h-14:00h</li>
              <li>15:30h-18:00h</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Borde separador */}
      <div className="w-full border-t border-gray-800"></div>

      {/* Sección inferior del footer */}
      <div className="content-container py-6">
        <div className="flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <p>
            © {new Date().getFullYear()} Jarad Pet Food. <T keyName="footer.rights">Todos los derechos reservados.</T>
          </p>

          {/* Métodos de pago */}
          <div className="mt-4 md:mt-0">
            <p className="mb-2 text-center md:text-right">
              <T keyName="footer.payment_methods">Métodos de pago aceptados</T>
            </p>
            <div className="flex space-x-3 justify-center md:justify-end">
              <div className="px-3 h-6 bg-gray-800 rounded flex items-center justify-center">
                <span className="text-xs text-gray-400">Transferencia bancaria</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;